import styled from "styled-components";

export const FunnelContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 10px;

  height: 300px;
  border: 1px solid rgb(241, 234, 234);
  border-radius: 5px;
  width: 100%;
  font-family: "Rubik";
  overflow: hidden;

  > div {
    flex: 60%;
  }
  > svg {
    flex: auto;
  }

  // optional title on top of graph
  > p {
    position: absolute;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
  }

  @media print {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  ${({ styling }) => styling}
`;

export const TooltipBox = styled.div`
  padding: 12px;
  color: #ffffff;
  background-color: #222222;
  border-radius: 4px;
  max-width: 250px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  > strong {
    margin-bottom: 4px;
  }
`;
